// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminEditCallInfo_wrapper__3HmqH"};